import React, { createContext, useContext, useEffect, useState } from "react";
import { me } from "../lib/authApi";
import { normalizeUser } from "./roles";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    async function refresh() {
        try {
            const u = await me();
            setUser(normalizeUser(u));
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        refresh();
    }, []);

    return (
        <AuthCtx.Provider value={{ user, setUser, loading, refresh }}>
            {children}
        </AuthCtx.Provider>
    );
}

export function useAuth() {
    return useContext(AuthCtx);
}